import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"
import type { ModuleInverterCompatibilityResponseDto } from "~/api/dto/equipment-dto"
import { equipmentService } from "~/api/services/equipment.service"

export default function useCurrentModuleEquipment(
  proposalId: string,
  options?: { enabled?: boolean; onError?: (error: unknown) => void },
): UseQueryResult<ModuleInverterCompatibilityResponseDto, unknown> {
  return useQuery({
    queryKey: queryKeys.equipment.moduleInverterCompatibility(proposalId),
    queryFn: () => equipmentService.fetchModuleInverterCompatibility(proposalId),
    enabled: Boolean(proposalId) && options?.enabled !== false,
    onError: options?.onError,
  })
}
